import { isOntra } from '^/api2/getRentalCarOfficeLocationsByCity/OnlineTravelOfficeLocations.constants';
import { CityCodeType } from '^/types/__BrandedLocationTypes';

/** 편도 반납이 불가능한 도시를 선택했는지 여부를 반환합니다. */
export const hasBlockedDifferentReturnCity = (cityCode: CityCodeType | null | undefined): boolean =>
  !!cityCode && (isOntra(cityCode) || cityCode === 'OKA');
